import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import imgControle1 from '../img/controle-1.jpg'
import imgControle2 from '../img/controle-2-lilas.png'
import imgControle3 from '../img/controle-3.jpg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  h3 {
    color: #8e8fc7;
  }
  .half-text {
    display: flex;
    justify-content: space-between;
    p {
      width: 58%;
      margin-right:30px;
      order: 1;
      @media ${device.mobileL} {
        width: 100%;
        order: 2;
      }
    }
    img {
      width: 40%;
      height:80%;
      margin-top: -360px;
      order: 2;
      @media ${device.mobileL} {
        width: 100%;
        margin-top: 0px;
        margin-bottom: 0em;
        order: 1;
      }
    }
    :nth-of-type(3){
      img {
        margin-top: 0px;
      }
    }
    @media ${device.mobileL} {
      display:block;
    }
  }
  .inner {
    display:flex;
    justify-content: space-between;
    align-content:center;
    div{
        width:50%;
        align-self:center;
        @media ${device.mobileL} {
          width:100%;
        }
    }
    p {
      font-size: 0.8em;
      @media ${device.mobileL} {
        padding:0 ;
      }
    }
    img{
      height:100%;
      @media ${device.mobileL} {
        width:100%;
      }
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    h2 {
      color: #8e8fc7;
      margin-top: 0;
    }
    @media ${device.mobileL} {
      display:block;
    }
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
  :nth-of-type(2){
    h2{
      color:#8E8FC7;
    }
    @media ${device.mobileL} {
    padding-top: 0em;
    }
  }
  :nth-of-type(3) {
    background-color:#FF8F8C;
    color:#ffffff;
  }
  :nth-of-type(5) {
    background:${colors.verdeGradiente};
    color:#ffffff;
    h2{
      color:#F4EDC6
    }
    strong{
      color:#FFE17E;
    }
  }
  :nth-of-type(6) {
    background:${colors.lilasGradiente};
    color:#ffffff;
    padding:0;
    .inner{
      .gatsby-image-wrapper{
        width:56%;
        height:354px;
        @media ${device.mobileL} {
          max-height:250px;
        }
      }
    }
    @media ${device.mobileL} {
      padding:2em;
      overflow: hidden;
    }
  }
    h2{
      color:#F4EDC6
    }
  }
  :nth-of-type(8) {
    background:${colors.laranjaGradiente};
    color:#ffffff;
    h2{
      color:#F4EDC6
    }
    .inner {
      .gatsby-image-wrapper{
        width:38.5%;
      }
      div{
        width:60%;
        @media ${device.mobileL} {
          width:100%;
          padding-bottom:2em;
        }
      }
    }
  }
`

export const ControledeInfeccaoHospitalarTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'O Santa Joana',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="221px"
          bottom="0"
          imgWidth="48.5%"
          titleWidth="445px"
          overflow="visible"
          imgInner
          mobileTop="-19%"
        />
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[0].tituloDaSessao)}</h2>
          </div>
          <div className="center half-text">
            <div>{parse(sessoes[0].texto)}</div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center half-text">
            <img
              src={sessoes[1].imagemDaSessao.sourceUrl}
              alt="Controle"
              className="offsetImgStart"
            />
            {parse(sessoes[1].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">{parse(sessoes[2].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[3].tituloDaSessao)}</h2>
            {parse(sessoes[3].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>{parse(sessoes[4].texto)}</div>
            {sessoes[4].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[4].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Segurança"
                className="offsetImgEnd"
              />
            ) : (
              <img
                src={sessoes[4].imagemDaSessao.sourceUrl}
                alt="Segurança"
                className="offsetImgEnd"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">{parse(sessoes[5].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="center inner">
            <div>
              <h2>{parse(sessoes[6].tituloDaSessao)}</h2>
              {parse(sessoes[6].texto)}
            </div>
            {sessoes[6].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[6].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Segurança"
                className="offsetImgEnd"
              />
            ) : (
              <img
                src={sessoes[6].imagemDaSessao.sourceUrl}
                alt="Segurança"
                className="offsetImgEnd"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">{parse(sessoes[6].texto)}</div>
        </GroupContent>
      </Container>
    </>
  )
}

ControledeInfeccaoHospitalarTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const ControledeInfeccaoHospitalar = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <ControledeInfeccaoHospitalarTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

ControledeInfeccaoHospitalar.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ControledeInfeccaoHospitalar

export const ControledeInfeccaoHospitalarQuery = graphql`
  query ControledeInfeccaoHospitalarById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
